import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function postalCodeValidator(enableValidation: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!enableValidation) {
      return null;
    }

    const postalCode = control?.value.toString().trim();
    const postalCodePattern = /^\d{5}$/;

    const valid = postalCodePattern.test(postalCode);
    return valid ? null : { invalidPostalCode: { message: $localize`Please enter a valid postal code. It should be exactly 5 digits.` } };
  };
}
